import React, { useEffect, useState } from "react";
import { TreeSelect } from "antd";
import { useSelector } from "react-redux";

const TreeSelectCustom = ({
  label,
  data,
  idKey, 
  nameKey, 
  valueKey,
  selectedValues,   
  onSelect, 
}) => {
  const [internalSelectedValues, setInternalSelectedValues] = useState(selectedValues); 

  console.log(data)
  // const treeData = data?.map((item) => ({
  //   key: item[idKey]?.toString(),
  //   title: item[nameKey],
  //   value: item[valueKey],
  // }));
  const treeData = data?.map((item) => ({
    key: item.parameterid?.toString()||0,
    title: item.parametername||'',
    value: item.parametername||'', 
  }));
  console.log(internalSelectedValues)

  console.log(treeData)

  // Update the selected values when selectedValues prop changes
  useEffect(() => {
    setInternalSelectedValues(selectedValues);
  }, [data,selectedValues]);

  const modeselect = useSelector((state) => state.darkMode);

  const { isdarkMode } = modeselect;

  return (
    <div className="flex items-center">
      <label className="pr-3 w-32 text-left">{label || ''}</label>
      <TreeSelect
        mode="multiple"
        placeholder={`Select ${label || ''}`}
        treeData={treeData}
        maxTagCount={2}
        treeCheckable={true}
        className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}
        dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
        onChange={(values) => {
          setInternalSelectedValues(values);
          onSelect(values);
        }}
        value={internalSelectedValues}
      />
      
    </div>
  );
};

export default TreeSelectCustom;
